import * as S from './index.style'
import React, { ElementType, useState } from 'react'
import Grid from 'components/Grid'
import { MascaraInteiro } from 'components/Mascara/Inteiro'
import { MascaraDecimal } from 'components/Mascara/Decimal'
import { InputBaseComponentProps } from '@material-ui/core/InputBase'
import TextField from '@material-ui/core/TextField'
import { DadosConstrucao, ValidacaoDadosConstrucao } from 'models/Viabilidade/Construcao'
import FieldInfo from 'components/FieldInfo'
import { ajudaColchaoLancamento, ajudaCurvaVendas } from 'helpers/Constantes/Mensagens'

const CardConstrucao: React.FC<{ dadosConstrucao: DadosConstrucao; dadosConstrucaoHandler: (novoValor: DadosConstrucao) => void }> = ({
  dadosConstrucao,
  dadosConstrucaoHandler
}) => {
  const [mensagensErro, setMensagensErro] = useState(new ValidacaoDadosConstrucao())
  const [valores, setValores] = useState(dadosConstrucao)

  const replaceState = (event: React.ChangeEvent<HTMLInputElement>): Record<string, unknown> => {
    const state = { ...valores } as Record<string, unknown>
    state[event.target.name] = event.target.value
    return state
  }

  const camposHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const state = replaceState(event) as DadosConstrucao
    setValores(state)
    dadosConstrucaoHandler(state)
  }

  const validarCustoCasa = () => {
    const erroCustoCasa = mensagensErro.validarInputUsuario(valores.custoCasa)

    const validador = new ValidacaoDadosConstrucao(erroCustoCasa, mensagensErro.colchaoLancamento, mensagensErro.duracaoObra, mensagensErro.prazoTotalVendas)

    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarColchaoLancamento = () => {
    const erroColchaoLancamento = mensagensErro.validarColchaoLancamento(valores.colchaoLancamento)

    const validador = new ValidacaoDadosConstrucao(mensagensErro.custoCasa, erroColchaoLancamento, mensagensErro.duracaoObra, mensagensErro.prazoTotalVendas)

    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarDuracaoObra = () => {
    const erroDuracaoObra = mensagensErro.validarDuracaoObra(valores.duracaoObra)

    const validador = new ValidacaoDadosConstrucao(mensagensErro.custoCasa, mensagensErro.colchaoLancamento, erroDuracaoObra, mensagensErro.prazoTotalVendas)

    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarPrazoTotalVendas = () => {
    const erroPrazoTotalVendas = mensagensErro.validarPrazoTotalVendas(valores.prazoTotalVendas)

    const validador = new ValidacaoDadosConstrucao(mensagensErro.custoCasa, mensagensErro.colchaoLancamento, mensagensErro.duracaoObra, erroPrazoTotalVendas)

    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarCard = (validador: ValidacaoDadosConstrucao) => {
    const state = { ...valores } as DadosConstrucao

    state.valido = validador.validarTodosCampos(state)
    setValores(state)
    dadosConstrucaoHandler(state)
  }

  return (
    <S.Wrapper>
      <Grid orientacao="column" gridTemplateColumns="240px" gridTemplateRow="1fr" gridGap="56px">
        <section>
          <S.NomeSecao>Custo de Construção</S.NomeSecao>
          <div>
            <S.Label>Custo Casa (R$/Unid)</S.Label>
            <TextField
              placeholder="000.000,00"
              type="text"
              name="custoCasa"
              data-cy="campocustoCasa"
              value={valores.custoCasa}
              onChange={camposHandler}
              onBlur={validarCustoCasa}
              variant="outlined"
              size="small"
              InputProps={{
                inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
              }}
              error={mensagensErro.custoCasa != ''}
              helperText={mensagensErro.custoCasa}
            />
          </div>
        </section>
        <section>
          <S.NomeSecao>Duração Do Empreendimento</S.NomeSecao>
          <Grid orientacao="column" gridTemplateColumns="repeat(2,260px)" gridTemplateRow="1fr" gridGap="48px" margin="0 0 56px 0">
            <div>
              <S.Label>Duração de Obra (meses)</S.Label>
              <TextField
                placeholder="00"
                type="text"
                name="duracaoObra"
                data-cy="campoDuracaoObra"
                value={valores.duracaoObra}
                onChange={camposHandler}
                onBlur={validarDuracaoObra}
                variant="outlined"
                size="small"
                InputProps={{
                  inputComponent: MascaraInteiro as unknown as ElementType<InputBaseComponentProps>,
                  inputProps: { maxLength: 2 }
                }}
                error={mensagensErro.duracaoObra != ''}
                helperText={mensagensErro.duracaoObra}
              />
            </div>
            <div>
              <S.Label>
                Colchão Lançamento - Obra (meses)
                <FieldInfo title={ajudaColchaoLancamento} dataCy="fieldInfoColchaoLancamento" />
              </S.Label>
              <TextField
                placeholder="00"
                type="text"
                name="colchaoLancamento"
                data-cy="campoColchaoLancamento"
                value={valores.colchaoLancamento}
                onChange={camposHandler}
                onBlur={validarColchaoLancamento}
                variant="outlined"
                size="small"
                InputProps={{
                  inputComponent: MascaraInteiro as unknown as ElementType<InputBaseComponentProps>,
                  inputProps: { maxLength: 2 }
                }}
                error={mensagensErro.colchaoLancamento != ''}
                helperText={mensagensErro.colchaoLancamento}
              />
            </div>
          </Grid>
        </section>
      </Grid>
      <S.NomeSecao>Curva de Vendas</S.NomeSecao>
      <Grid orientacao="column" gridTemplateColumns="240px" gridTemplateRow="1fr" gridGap="0">
        <div>
          <S.Label>
            Prazo Total de Vendas (meses)
            <FieldInfo title={ajudaCurvaVendas} dataCy="fieldInfoCurvaVendas" />
          </S.Label>
          <TextField
            placeholder="00"
            type="text"
            name="prazoTotalVendas"
            data-cy="campoPrazoTotalVendas"
            value={valores.prazoTotalVendas}
            onChange={camposHandler}
            onBlur={validarPrazoTotalVendas}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraInteiro as unknown as ElementType<InputBaseComponentProps>,
              inputProps: { maxLength: 2 }
            }}
            error={mensagensErro.prazoTotalVendas != ''}
            helperText={mensagensErro.prazoTotalVendas}
          />
        </div>
      </Grid>
    </S.Wrapper>
  )
}

export default CardConstrucao
